import Phaser from 'phaser'

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' })
  }

  preload() {
    // Create loading bar
    const width = this.cameras.main.width
    const height = this.cameras.main.height

    const progressBar = this.add.graphics()
    const progressBox = this.add.graphics()
    progressBox.fillStyle(0x222222, 0.8)
    progressBox.fillRect(width / 2 - 160, height / 2 - 25, 320, 50)

    const loadingText = this.add.text(width / 2, height / 2 - 50, 'Ladowanie...', {
      fontSize: '20px',
      color: '#00FF88',
    })
    loadingText.setOrigin(0.5, 0.5)

    // Progress events
    this.load.on('progress', (value: number) => {
      progressBar.clear()
      progressBar.fillStyle(0x00FF88, 1)
      progressBar.fillRect(width / 2 - 150, height / 2 - 15, 300 * value, 30)
    })

    this.load.on('complete', () => {
      progressBar.destroy()
      progressBox.destroy()
      loadingText.destroy()
    })

    // Generate placeholder assets programmatically
    this.generatePlaceholderAssets()
  }

  generatePlaceholderAssets() {
    // Generate colored square sprites for each role
    const roles = [
      { key: 'player_flux', color: 0x00FF66 },
      { key: 'player_logic', color: 0x4488FF },
      { key: 'player_spark', color: 0xFF8844 },
      { key: 'player_echo', color: 0xAA44FF },
    ]

    roles.forEach(({ key, color }) => {
      // Create a simple 32x48 sprite for each role
      const graphics = this.make.graphics({}, false)

      // Body
      graphics.fillStyle(color, 1)
      graphics.fillRoundedRect(2, 8, 28, 36, 4)

      // Head
      graphics.fillStyle(color, 1)
      graphics.fillCircle(16, 8, 8)

      // Glow effect
      graphics.lineStyle(2, 0xffffff, 0.3)
      graphics.strokeRoundedRect(2, 8, 28, 36, 4)
      graphics.strokeCircle(16, 8, 8)

      graphics.generateTexture(key, 32, 48)
      graphics.destroy()
    })

    // Generate isometric floor tile
    const tileGraphics = this.make.graphics({}, false)

    // Dark floor tile (64x32 isometric)
    tileGraphics.fillStyle(0x1a3d40, 1)
    tileGraphics.fillPoints([
      { x: 32, y: 0 },
      { x: 64, y: 16 },
      { x: 32, y: 32 },
      { x: 0, y: 16 },
    ], true)

    // Grid lines
    tileGraphics.lineStyle(1, 0x00FF88, 0.2)
    tileGraphics.strokePoints([
      { x: 32, y: 0 },
      { x: 64, y: 16 },
      { x: 32, y: 32 },
      { x: 0, y: 16 },
      { x: 32, y: 0 },
    ])

    tileGraphics.generateTexture('tile_floor', 64, 32)
    tileGraphics.destroy()

    // Generate wall tile
    const wallGraphics = this.make.graphics({}, false)
    wallGraphics.fillStyle(0x0A2E36, 1)
    wallGraphics.fillPoints([
      { x: 32, y: 0 },
      { x: 64, y: 16 },
      { x: 32, y: 32 },
      { x: 0, y: 16 },
    ], true)
    wallGraphics.lineStyle(2, 0x00FF88, 0.5)
    wallGraphics.strokePoints([
      { x: 32, y: 0 },
      { x: 64, y: 16 },
      { x: 32, y: 32 },
      { x: 0, y: 16 },
      { x: 32, y: 0 },
    ])
    wallGraphics.generateTexture('tile_wall', 64, 32)
    wallGraphics.destroy()

    // Interactive object marker
    const markerGraphics = this.make.graphics({}, false)
    markerGraphics.fillStyle(0x00FF88, 0.8)
    markerGraphics.fillCircle(16, 16, 12)
    markerGraphics.lineStyle(2, 0xffffff, 1)
    markerGraphics.strokeCircle(16, 16, 12)
    markerGraphics.generateTexture('marker', 32, 32)
    markerGraphics.destroy()
  }

  create() {
    this.scene.start('GameScene')
  }
}
